import {
  dispatch,
  updateChatActionDrawer,
  updateSelectedMessage,
} from '@zonofi/seller-rtk-store';
import {
  ChatActionType,
  MessageActionType,
  MessageEnvelope,
} from '@zonofi/common';
import { ButtonPayload } from '../types';

export const onButtonPress = (
  type: string,
  props: MessageEnvelope | ButtonPayload
) => {
  if ((Object.values(ChatActionType) as string[]).includes(type)) {
    const payload = props as ButtonPayload;
    const { customerId, entityId, suggestions, status, formAnswerId } = payload;
    dispatch(
      updateChatActionDrawer({
        open: true,
        type: type as ChatActionType,
        customerId,
        entityId,
        orderStatus: status,
        suggestions,
        formAnswerId,
      })
    );
  } else {
    const payload = props as MessageEnvelope;
    dispatch(
      updateSelectedMessage({
        action: type as MessageActionType,
        envelope: payload,
        isLoading: true,
      })
    );
  }
};
